import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, setBlockTracking as _setBlockTracking, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "card" };
const _hoisted_3 = {
    key: 0,
    class: "px-3 lg:px-4 pt-3 pb-2"
};
const _hoisted_4 = { class: "flex justify-between items-center" };
const _hoisted_5 = { class: "font-semibold" };
const _hoisted_6 = ["aria-label", "title"];
const _hoisted_7 = { class: "my-1 text-muted collapsible-content" };
const _hoisted_8 = { class: "hidden-scrollbar overflow-x-scroll" };
const _hoisted_9 = { class: "table w-full divide-y divide-(--default-border-color) not-print:min-w-3xl" };
const _hoisted_10 = { class: "divide-y divide-(--default-border-color)" };
const _hoisted_11 = {
    scope: "col",
    class: "font-normal pt-3 pb-2 text-start ps-3 lg:ps-4"
};
const _hoisted_12 = {
    key: 0,
    scope: "col",
    class: "font-normal pt-3 pb-2 text-start"
};
const _hoisted_13 = {
    scope: "col",
    class: "font-normal pt-3 pb-2 text-start"
};
const _hoisted_14 = {
    scope: "col",
    class: "font-normal pt-3 pb-2 text-start"
};
const _hoisted_15 = {
    scope: "col",
    class: "font-normal pt-3 pb-2 text-start pe-3 lg:pe-4"
};
const _hoisted_16 = { class: "divide-y divide-(--default-border-color)" };
const _hoisted_17 = { class: "whitespace-nowrap text-start ps-3 lg:ps-4" };
const _hoisted_18 = {
    key: 0,
    class: "text-start"
};
const _hoisted_19 = ["textContent"];
const _hoisted_20 = ["textContent"];
const _hoisted_21 = { class: "text-start" };
const _hoisted_22 = ["textContent"];
const _hoisted_23 = ["textContent"];
const _hoisted_24 = { class: "text-start" };
const _hoisted_25 = ["textContent"];
const _hoisted_26 = ["textContent"];
const _hoisted_27 = { class: "text-start pe-3 lg:pe-4" };
const _hoisted_28 = ["textContent"];
const _hoisted_29 = ["textContent"];
const _hoisted_30 = { class: "text-end lg:hidden print:hidden text-sm text-muted" };
import { computed, ref } from 'vue';
import { ___, toFixedNumberStr } from '@ts/common/language';
import { closest } from '@ts/common/math';
import { kcalToG } from '@ts/common/nutrition';
import SvgVue from '@ts/components/utils/SvgVue.vue';
import {} from '@ts/common/datasets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CompareHrFueling',
    props: {
        dataA: { default: undefined },
        dataB: { default: undefined },
        help: { type: Boolean, default: false },
        header: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const showHelp = ref(false);
        function sideHasCoeffs(d) {
            return !(d === undefined || d.heartrate_c0 === null || d.heartrate_c1 === null);
        }
        const hasHeartRateCoeffs = computed(() => {
            return sideHasCoeffs(props.dataA) && sideHasCoeffs(props.dataB);
        });
        function hrAtPower(data, power) {
            const raw = Math.round(data.heartrate_c0 * power + data.heartrate_c1);
            return data.heartrate_max === null ? raw : Math.min(data.heartrate_max, raw);
        }
        function gPerHAtPower(data, power, substrate) {
            const cm = data.chart_metabolism;
            if (!cm || !cm.power || cm.power.length === 0)
                return '-';
            const idx = closest(power, cm.power);
            if (idx < 0)
                return '-';
            const kcal = (substrate === 'carb' ? cm.energy_carbo_per_hour[idx] : cm.energy_fat_per_hour[idx]) ?? 0;
            return toFixedNumberStr(kcalToG(kcal, substrate), substrate === 'carb' ? 0 : 1) ?? '-';
        }
        const rows = computed(() => {
            const a = props.dataA;
            const b = props.dataB;
            if (a === undefined || b === undefined)
                return [];
            // Labels mirror the names used in the "Training Zones" component (Zones.vue).
            const defs = [
                { label: ___({ en: 'Active Recovery (AR)', de: 'Kompensation (KB)' }), powerA: a.zone1?.avg?.power, powerB: b.zone1?.avg?.power },
                { label: ___({ en: 'Basic Endurance 1 (E1)', de: 'Grundlagenausdauer 1 (G1)' }), powerA: a.zone2?.avg?.power, powerB: b.zone2?.avg?.power },
                { label: ___({ en: 'Basic Endurance 2 (E2)', de: 'Grundlagenausdauer 2 (G2)' }), powerA: a.zone3?.avg?.power, powerB: b.zone3?.avg?.power },
                { label: ___({ en: 'Fatmax (FM)', de: 'Fatmax (FM)' }), powerA: a.fatmax_abs, powerB: b.fatmax_abs },
                { label: ___({ en: 'Threshold (TH)', de: 'Entwicklungsbereich (EB)' }), powerA: a.zone4?.avg?.power, powerB: b.zone4?.avg?.power },
            ].filter((d) => typeof d.powerA === 'number' && typeof d.powerB === 'number' && isFinite(d.powerA) && isFinite(d.powerB));
            return defs.map((d) => ({
                label: d.label,
                hrA: hasHeartRateCoeffs.value ? hrAtPower(a, d.powerA) : null,
                hrB: hasHeartRateCoeffs.value ? hrAtPower(b, d.powerB) : null,
                powerA: Math.round(d.powerA),
                powerB: Math.round(d.powerB),
                carbA: gPerHAtPower(a, d.powerA, 'carb'),
                carbB: gPerHAtPower(b, d.powerB, 'carb'),
                fatA: gPerHAtPower(a, d.powerA, 'fat'),
                fatB: gPerHAtPower(b, d.powerB, 'fat'),
            }));
        });
        return (_ctx, _cache) => {
            return (rows.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (__props.header)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, _toDisplayString(hasHeartRateCoeffs.value
                                        ? _unref(___)({ en: 'Heart-Rate and Metabolism Overview', de: 'Herzfrequenz- und Stoffwechselübersicht' })
                                        : _unref(___)({ en: 'Metabolism Overview', de: 'Stoffwechselübersicht' })), 1 /* TEXT */),
                                    (__props.help)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: _cache[1] || (_cache[1] = ($event) => (showHelp.value = !showHelp.value)),
                                            type: "button",
                                            class: "btn text-gray-350 dark:text-gray-450 hover:text-primary-500",
                                            "aria-label": _unref(___)({ en: 'Toggle help', de: 'Hilfe ein- und ausblenden' }),
                                            title: _unref(___)({ en: 'Help', de: 'Hilfe' })
                                        }, [
                                            _cache[0] || (_setBlockTracking(-1, true),
                                                (_cache[0] = _createVNode(SvgVue, {
                                                    class: "w-4 h-4",
                                                    icon: "lucide/circle-question-mark"
                                                })).cacheIndex = 0,
                                                _setBlockTracking(1),
                                                _cache[0])
                                        ], 8 /* PROPS */, _hoisted_6))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                (__props.help)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["collapsible", showHelp.value ? 'expanded' : ''])
                                    }, [
                                        _createElementVNode("div", _hoisted_7, _toDisplayString(hasHeartRateCoeffs.value
                                            ? _unref(___)({
                                                en: 'Heart-rate guide value and the corresponding carbohydrate and fat usage at key intensities, for both analyses (value vs. comparison).',
                                                de: 'Herzfrequenz-Richtwert sowie zugehöriger Kohlenhydrat- und Fettverbrauch bei wichtigen Intensitäten, für beide Analysen (Wert vs. Vergleich).',
                                            })
                                            : _unref(___)({
                                                en: 'Carbohydrate and fat usage at key intensities, for both analyses (value vs. comparison).',
                                                de: 'Kohlenhydrat- und Fettverbrauch bei wichtigen Intensitäten, für beide Analysen (Wert vs. Vergleich).',
                                            })), 1 /* TEXT */)
                                    ], 2 /* CLASS */))
                                    : _createCommentVNode("v-if", true)
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("table", _hoisted_9, [
                                _createElementVNode("thead", _hoisted_10, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_11, _toDisplayString(_unref(___)({ en: 'Intensity', de: 'Intensität' })), 1 /* TEXT */),
                                        (hasHeartRateCoeffs.value)
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_12, _toDisplayString(_unref(___)({ en: 'Heart rate', de: 'Herzfrequenz' })) + " [bpm]", 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("th", _hoisted_13, _toDisplayString(_unref(___)({ en: 'Power', de: 'Leistung' })) + " [W]", 1 /* TEXT */),
                                        _createElementVNode("th", _hoisted_14, _toDisplayString(_unref(___)({ en: 'Carbohydrates', de: 'Kohlenhydrate' })) + " [g/h]", 1 /* TEXT */),
                                        _createElementVNode("th", _hoisted_15, _toDisplayString(_unref(___)({ en: 'Fat', de: 'Fett' })) + " [g/h]", 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("tbody", _hoisted_16, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: row.label
                                        }, [
                                            _createElementVNode("td", _hoisted_17, _toDisplayString(row.label), 1 /* TEXT */),
                                            (hasHeartRateCoeffs.value)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                                                    _cache[4] || (_cache[4] = _createTextVNode("~", -1 /* CACHED */)),
                                                    _createElementVNode("span", {
                                                        textContent: _toDisplayString(row.hrA)
                                                    }, null, 8 /* PROPS */, _hoisted_19),
                                                    _cache[5] || (_cache[5] = _createTextVNode(" vs. ~", -1 /* CACHED */)),
                                                    _createElementVNode("span", {
                                                        textContent: _toDisplayString(row.hrB)
                                                    }, null, 8 /* PROPS */, _hoisted_20)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createElementVNode("td", _hoisted_21, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(row.powerA)
                                                }, null, 8 /* PROPS */, _hoisted_22),
                                                _cache[6] || (_cache[6] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(row.powerB)
                                                }, null, 8 /* PROPS */, _hoisted_23)
                                            ]),
                                            _createElementVNode("td", _hoisted_24, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(row.carbA)
                                                }, null, 8 /* PROPS */, _hoisted_25),
                                                _cache[7] || (_cache[7] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(row.carbB)
                                                }, null, 8 /* PROPS */, _hoisted_26)
                                            ]),
                                            _createElementVNode("td", _hoisted_27, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(row.fatA)
                                                }, null, 8 /* PROPS */, _hoisted_28),
                                                _cache[8] || (_cache[8] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(row.fatB)
                                                }, null, 8 /* PROPS */, _hoisted_29)
                                            ])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                            _cache[2] || (_setBlockTracking(-1, true),
                                (_cache[2] = _createVNode(SvgVue, {
                                    class: "w-3 h-3 inline-block",
                                    icon: "lucide/chevron-left"
                                })).cacheIndex = 2,
                                _setBlockTracking(1),
                                _cache[2]),
                            _cache[9] || (_cache[9] = _createTextVNode("swipe me", -1 /* CACHED */)),
                            _cache[3] || (_setBlockTracking(-1, true),
                                (_cache[3] = _createVNode(SvgVue, {
                                    class: "w-3 h-3 inline-block",
                                    icon: "lucide/chevron-right"
                                })).cacheIndex = 3,
                                _setBlockTracking(1),
                                _cache[3])
                        ])
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
